import React from 'react';
import { Navigate } from 'react-router-dom';

export const CommonRoute = ({ isAuthenticated = false, children }) => {
    return isAuthenticated ? <Navigate to="/dashboard" /> : <>{children}</>;
};

export default CommonRoute;
